import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable()
export class CommonService {
  header: HttpHeaders;
  loggedClientObj: any;
  loggedInClientID: string;
  loggedInClientToken: string | string[];
  errorStatus: any;
  sharedData:any;

  constructor(private http: HttpClient, private cookieService: CookieService) {
    this.header = new HttpHeaders().set('Content-type', 'application/json');
    if (this.cookieService.get('companyAuth')) {
      const companyObj = JSON.parse( this.cookieService.get('companyAuth') );
      this.loggedInClientID = companyObj.CompanyInfo.ID;
      this.loggedClientObj = companyObj.CompanyInfo;
      this.loggedInClientToken = companyObj.Token;
    }
    this.header = new HttpHeaders({
      'Token': this.loggedInClientToken !== undefined ? this.loggedInClientToken : ''
   });
  }

  // Common Request Urls
  // Get List
  // Url: http://127.0.0.1:3000/company/
  getList(url) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.get<any>(environment.apiUrl + url, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  getJapaneseFont(url) {
    return this.http.get<any>(url,{ responseType: 'text' as 'json'}).pipe(
      map(res => {
        return res;
      })
    );
  }

  clientVerification(ClientID) {
    const httpOptions = {
      headers: this.header
    };
    return this.http
      .get<any>(environment.apiUrl + `Common/ClientVerification/` +ClientID,httpOptions )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

   emailSettingAdCancellation(ClientID) {
    const httpOptions = {
      headers: this.header
    };
    return this.http
      .get<any>(environment.apiUrl + `Common/EmailSettingAdCancellation/` +ClientID, httpOptions )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  // httpOptions Will be added for authentication put

  // Add List
  // Url: http://127.0.0.1:3000/company/
  /*{
    "name":  "Company Name",
    "email":  "Company@email.com",
    "tel":  "0000252525"
  }*/

  createList(url, params) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.post<any>(environment.apiUrl + url, params, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }


  clientLogin(url, params, headerObj) {
    debugger;
    return this.http.post<any>(url, params, headerObj).pipe(
      map((res : any)=> {
        if(res.Success === true && res.CompanyInfo.IsEmailVerified === true){
          this.loggedInClientID = res.CompanyInfo.ID;
          this.loggedClientObj = res.CompanyInfo;
          this.loggedInClientToken = res.Token;
          this.header = new HttpHeaders({
            'Token': this.loggedInClientToken
         });
        }
        return res;
      })
    );
  }

  // Update List (PUT Method)
  // Url: http://127.0.0.1:3000/company/1
  /*{
    "name":  "Company Name",
    "email":  "Company@email.com",
    "tel":  "0000252525"
  }*/

  updateList(url, params) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.put<any>(url, params, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  // Delete List (Patch Method)
  // Url: http://127.0.0.1:3000/company/1

  deleteList(url) {
    const httpOptions = {
      headers: this.header
    };
    return this.http.delete<any>(url, httpOptions).pipe(
      map(res => {
        return res;
      })
    );
  }

  getCountryList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Country/GetCountryList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getPrefectureList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Prefecture/GetPrefectureList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getCurrenctyList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Currency/GetCurrencyList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getIndustryClassificationList(lang) {
    return this.http
      .get<any>(
        environment.apiUrl +
          `IndustryClassification/GetIndustryClassificationList/` +
          lang
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getCountryAreaList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `CountryArea/GetCountryAreaList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getJobCategoryList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Common/GetJobCategoryList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getJobCategoryDetailListById(id, lang) {
    return this.http
      .get<any>(
        environment.apiUrl +
          `Common/GetJobCategoryDetailsById/` +
          id +
          `/` +
          lang
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }
  getLanguageList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Language/GetLanguageList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }
  getLanguageLevelList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Language/GetLanguageLevelList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getNationalityList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Nationality/GetNationalityList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }
  getOtherCareerList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `OtherCareer/GetOtherCareerList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  getTranslationQuotation(param, lang) {
    return this.http
      .get<any>(
        environment.apiUrl +
          `OptionEstimateService/getTranslationQuotation/` +
          param +
          `/` +
          lang
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  onClickMailServiceCheckQuotationResult(id) {
    return this.http
      .get<any>(
        environment.apiUrl +
          `OptionEstimateService/GetMailServiceCostById/` +
          id
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  SaveServiceOrder(ServiceOrderObject: any) {
    return this.http
      .post<any>(
        environment.apiUrl + `ServiceOrder/SaveServiceOrder`,
        JSON.stringify({ ServiceOrderObject }),
        { headers: this.header }
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  SaveJobPosting(jobPosting: any) {
    return this.http
      .post<any>(
        environment.apiUrl + `JobPost/SaveJobPost`,
        JSON.stringify({ jobPosting }),
        { headers: this.header }
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }
  getCityByPrefectureID(id, lang) {
    return this.http
      .get<any>(
        environment.apiUrl + `City/GetCityByPrefectureId/` + id + `/` + lang
      )
      .pipe(
        map(res => {
          return res;
        })
      );
  }

  //skills Registrations

  getStaffStrongSkillList(lang) {
    return this.http
      .get<any>(environment.apiUrl + `Common/GetStaffStrongSkillList/` + lang)
      .pipe(
        map(res => {
          return res;
        })
      );
  }
}


